<template>
    <body class="" v-bind:class="[absoluteClass, defaultClass]">
        <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
            <a class="navbar-brand">{{ data.name }}</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" >
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{{ $t('layers') }}</a>
                            <div class="dropdown-menu" v-if="this.toolLayers.length > 0">
                            <form>
                                <a class="dropdown-item" v-for="(item, i) in this.toolLayers" :key="i">
                                    <div v-if="item.name" class="custom-control custom-checkbox" >
                                        <input type="checkbox" :checked="item.visible" @click="toggleLayer(item)" class="custom-control-input" :id="item.name">
                                        <label class="custom-control-label" :for="item.name">{{ item.name }}</label>
                                    </div>
                                </a>
                            </form>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav px-3">
                    <li class="nav-item text-nowrap">
                        <router-link class="nav-link" :to="{ name: 'inspectiondetail', params: { id: this.$route.params.id } }">
                            {{ $t('back') }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </nav>

        <!-- Begin page content -->
        <div class="map-layout">
            <div class="map-viewport clearfix">
                <div ref="map" class="map"></div>
            </div>
            <aside class="side-form" v-if="isMounted" :class="{ 'side-form--open': showForm }">
                <div class="side-form__content" v-show="showForm">
                <FormTemplate
                    :formConstraints="formConstraints"
                    :formClass="formClass"
                    :tableForm="tableForm"
                    :data="data"
                    :template="data.form.formMaintenancePlanTemplate"
                    :formData="formData"
                />
                </div>
            </aside>
        </div>
        <div ref="popup" class="ol-popup">
            <a ref="popup-closer" class="ol-popup-closer"></a>
            <div ref="popup-content"></div>
        </div>
        <div class="fixed-bottom">
            <table v-if="filteredAttributes.length" id="mainTable" class="table table-sm table-bordered">
                <thead>
                    <tr>
                        <th class="text-center" style="width: 2%">#</th>
                        <th class="text-center" style="width: 2%"></th>
                        <th class="text-center" v-for="attr in filteredAttributes" :key="attr.key">
                            <u :name="attr.key"  class="pointer" @click="sortColumnBy(attr.key)">{{ attr.title }}
                                <i class="fas ml-1"
                                    :class="getSortIcon(attr.key)">
                                </i>
                            </u>
                        </th>
                    </tr>
                    <tr>
                        <th class="text-center" style="width: 2%">#</th>
                        <th class="text-center" style="width: 2%"></th>
                        <th class="text-center" v-for="attr in filteredAttributes" :key="attr.key">
                             <select v-if="isOneOf(attr)"
                                    class="form-control form-control-sm"
                                    :name="attr.key"
                                    :value="filterObject[attr.key] || ''"
                                    @change="filter(attr.key, $event.target.value)"
                                >
                                    <option value=""></option>
                                    <option v-for="opt in attr.oneOf" :key="opt.const" :value="opt.const">
                                        {{ opt.title }}
                                    </option>
                                </select>

                                <input v-else-if="attr.type === 'date'"
                                    type="date"
                                    class="form-control form-control-sm"
                                    :name="attr.key"
                                    :value="filterObject[attr.key] || ''"
                                    @input="filter(attr.key, $event.target.value)"
                                />

                                <input v-else-if="attr.type === 'number'"
                                    type="number"
                                    class="form-control form-control-sm"
                                    :name="attr.key"
                                    :value="filterObject[attr.key] || ''"
                                    @input="filter(attr.key, $event.target.value)"
                                />

                                <select v-else-if="attr.type === 'boolean'"
                                    class="form-control form-control-sm"
                                    :name="attr.key"
                                    :value="filterObject[attr.key] || ''"
                                    @change="filter(attr.key, $event.target.value)"
                                >
                                    <option value=""></option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select>

                                <input v-else
                                    type="text"
                                    class="form-control form-control-sm"
                                    :name="attr.key"
                                    :value="filterObject[attr.key] || ''"
                                    @input="filter(attr.key, $event.target.value)"
                                />
                            <!-- <input :name="attr.key" class="form-control form-control-sm" :value="filterObject[attr.key] || ''" @input="filter(attr.key, $event.target.value)"/> -->
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(tableFormRow, i) in this.tableForm" :key="tableFormRow.properties.OBJECTID || i" :class="{ 'table-row-editing': isEditingRow(tableFormRow) }">
                         <td class="text-center">
                            <i class="fas fa-times" @click="showDeleteRow(tableFormRow)"></i>
                        </td>
                        <td class="text-center">
                            <i class="fas fa-edit" @click="editRow(tableFormRow)"></i>
                        </td>
                        <td class="text-center" v-for="attr in filteredAttributes" :key="attr.key">
                            <span v-html="renderRow(attr, tableFormRow.properties[attr.key])" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <DeleteRowDialog v-show="showDeleteRowDialog" @confirm="deleteRow" @close="closeDeleteRowDialog"></DeleteRowDialog>
    </body>
</template>

<script>
import Map from "ol/Map";
import View from "ol/View";
import { register } from 'ol/proj/proj4';
import Overlay from 'ol/Overlay';
import Feature from "ol/Feature";
import { Icon, Style } from "ol/style";
import { Point } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { getFeaturesFromSections, defaultLineStyleFunction } from "../../utils/feature-ext-maintenance";
import { createBaseLayer } from "../../utils/layer-ext";
import { parseCoords } from "../../utils/geom-coords";
import ProjectApi from "../../api/server/project";
import NetApi from "../../api/server/net";
import Control from 'ol/control/Control';
import proj4 from 'proj4';
import src from "../../images/camera.svg";
import targetsrc from "../../images/target.png";
import { Modify, Select } from 'ol/interaction';
import { lineStringLengthToCoordinates, sliceLineString } from "../../utils/geom-length";
import moment from 'moment';
import MaintenanceApi from "../../api/server/maintenance";
import DeleteRowDialog from "./DeleteRowDialog.vue";
import { v4 as uuidv4 } from 'uuid';
import { singleClick } from "ol/events/condition";

function debounce(fn, wait = 400) {
    let t = null;
    return function (...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

export default {
    name: "Main",
    mounted() {
        this.getSummary();
        this.fetchTableDataDebounced = debounce(this.fetchTableData, 400);
    },
    destroyed() {
        this.destroyMap();
    },
    components: {
        DeleteRowDialog
    },
    notifications: {
        showVonBisError: { 
            title: 'Error!',
            message: 'Bis muss größer sein als Von!',
            type: 'error'
        },
    },
    watch: {
        formData: {
            handler(value) {
                for(var i in this.formDataClone) {
                    var archiveValue = this.formDataClone[i];

                    var foundProp = value[i];
                    if(foundProp && archiveValue != foundProp) {
                        this.$set(this.formClass, i, false);   
                    }
                }
            },
            deep: true
        },
        sectionFilter: function () {
            // Co když budeme chtít označit jinačí layers nez sections ?? (archivy)
            var lay = this.map.getLayers().getArray().find(layer => layer.get('name') == 'Sections');
            if(lay) {
                lay.changed();
            }
        }
    },
    computed: {
        storageKey() {
            return `maintenanceTableFilter_${this.$route.params.id}`;
        },
        filteredAttributes() {
            if(this.data && this.data.form && this.data.form.attributes) {
                const all = Object.entries(this.data.form.attributes).map(([key, def]) => ({
                    key,
                    ...(def || {}),
                }));
                const filtered = all.filter((a) => a.useInMaintenanceTable === true);

                return filtered.length > 0 ? filtered : all;
            } else {
                return [];
            }
        }
    },
    methods: {
        isEditingRow(row) {
            const rowId = row.properties.OBJECTID;
            return rowId === this.editingRowId;
        },
        isOneOf(attr) {
            return attr && attr.type === "object" && Array.isArray(attr.oneOf) && attr.oneOf.length > 0;
        },
        saveTableState() {
            const state = {
                sortBy: this.sortBy,
                filterObject: this.filterObject
            };
            
            localStorage.setItem(this.storageKey, JSON.stringify(state));
        },
        loadTableState() {
            const storageItem = localStorage.getItem(this.storageKey);
            if (!storageItem) {
                this.fetchTableData();
                return;
            }

            this.tableFiltersRestoring = true;

            try {
                const state = JSON.parse(storageItem);
                this.sortBy = state.sortBy || "";
                this.filterObject = state.filterObject || {};
            } finally {
                this.$nextTick(() => { 
                    this.tableFiltersRestoring = false;
                    this.fetchTableData();

                });
            }
        },
        getSortIcon(key) {
            if (!this.sortBy)
                return "fa-sort";
            if (this.sortBy === key) 
                return "fa-sort-up";
            if (this.sortBy === "-" + key)
                return "fa-sort-down";

            return "fa-sort";
        },
        buildQuery() {
            const params = new URLSearchParams();
            console.log(this.filterObject, this.sortBy)

            // filtr na sekci
            // var sectionId = this.selectLastFeature?.get("sectionId");
            // if(!sectionId)
            //     sectionId = this.selectLastFeature?.get("id");

            // if (sectionId) {
            //     params.set("sectionId", sectionId);
            // }

            // sorting 
            if (this.sortBy)
                params.set("sortBy", this.sortBy);

            // ostatní filtry 
            Object.entries(this.filterObject).forEach(([k, v]) => {
                if (k === "sortBy") 
                    return;
                if (v === null || v === undefined)
                    return;
                const s = String(v).trim();
                if (!s) return;
                    params.set(k, s);
            });

            const qs = params.toString();
            return qs ? `?${qs}` : "";
        },

        async fetchTableData() {
            const query = this.buildQuery();
            const list = await MaintenanceApi.list(this.data.id, query);
            this.tableForm = list;
            this.visibleMaintenanceIds = new Set(list.map(x => x.properties.OBJECTID));
            if(this.maintenanceLayer != null)
                this.maintenanceLayer.changed();
        },

        showDeleteRow(row) {
            this.rowToDelete = row;
            this.showDeleteRowDialog = true;
        },
        editRow(row) {
            if (!row) 
                return;

            this.formConstraints.formEditing = true;

            this.editingRowId = row.properties.OBJECTID;

            this.defaultFormData(true);
            Object.assign(this.formData, row.properties);

            this.formDataSection = {
                type: row.type,
                coordinates: row.coordinates,
                properties: row.properties
            };

            const oid = row.properties.OBJECTID;
            if (oid && this.maintenanceSource) {
                const f = this.maintenanceSource.getFeatureById(oid);
                const geometry = f.getGeometry();
                const extent = geometry.getExtent();

                // zoom na feature
                this.map.getView().fit(extent, {
                    size: this.map.getSize(),
                    padding: [0, 100, 100, -150],
                    maxZoom: 18
                });
                if (f && this.maintenanceSelect) {
                    this.maintenanceSelect.getFeatures().clear();
                    this.maintenanceSelect.getFeatures().push(f);
                }
            }           
        },
        closeDeleteRowDialog() {
            this.showDeleteRowDialog = false;
        },
        async deleteRow() {
            let { id } = this.data;
            let row = this.rowToDelete;
            if(!row) 
                row = { properties: { guid: this.formData.guid, OBJECTID: this.formData.OBJECTID }};
            
            const guid = row.properties.guid;
            const objectId = row.properties.OBJECTID;

            // Smažu záznam z DB
            await MaintenanceApi.delete(id, guid);
            // Smažu feature z mapy
            this.deleteMaintenanceFromMap(objectId);

            // tabulka
            this.removeRowFromTable(objectId, guid);

            this.showDeleteRowDialog = false;
            this.rowToDelete = null;

            this.defaultFormData();
            this.resetCursor();
        },
        removeRowFromTable(objectId, guid) {
            this.tableForm = this.tableForm.filter(row => {
                var rowObjectId = row.properties.OBJECTID;
                var rowGuid = row.properties.guid;

                if (objectId && rowObjectId === objectId) {
                    return false;
                }

                if (guid && rowGuid === guid) {
                    return false;
                }

                return true;
            });

            this.refreshVisibleMaintenanceIds();
        },
        refreshVisibleMaintenanceIds() {
            this.visibleMaintenanceIds = new Set(this.tableForm.map(x => x.properties.OBJECTID));

            if (this.maintenanceLayer) {
                this.maintenanceLayer.changed();
            }
        },
        getResult() {
            // Form componenta požaduje funkci getResult.
            return;
        },  
        stopEditingFormData() {
            this.formConstraints.formEditing = false;
            this.editingRowId = null;
            this.defaultFormData()
        },
        renderRow(attr, row) {
            if(attr.type === "boolean" && row){
                return '<i class="fas fa-check"></i>'
            } else if (attr.type === "boolean" && !row) {
                return ''
            } else {
                return row;
            }
        },
        async getSummary() {
            this.data = await ProjectApi.detail(this.$route.params.id);
            // načíst filtery z localStorage
            this.loadTableState();
            this.isMounted = true;
            await this.$nextTick();
            await this.initMap();

        },
        async sendData(type) {
            let { id } = this.data;

            if(this.formData.von > this.formData.bis) {
                this.showVonBisError();
                return;
            }
            // Naklonuju objekt 
            var formDataSectionClone = structuredClone(this.formDataSection);

            if(type == "update") {
                Object.assign(formDataSectionClone.properties, this.formData)
                var maintenancePlanContent = await MaintenanceApi.update(id, formDataSectionClone);
                this.upsertMaintenanceFeature(maintenancePlanContent);
            } else {
                this.$set(this.formData, "guid", uuidv4());
                this.$set(this.formData, "OBJECTID", uuidv4());
                var resultCoordinates = sliceLineString(formDataSectionClone.coordinates, parseFloat(this.formData.von), parseFloat(this.formData.bis));
                
                formDataSectionClone.coordinates = resultCoordinates;

                Object.assign(formDataSectionClone.properties, this.formData)
                var maintenancePlanContent = await MaintenanceApi.create(id, formDataSectionClone);
                this.upsertMaintenanceFeature(maintenancePlanContent);
                this.defaultFormData(true);
            }
            await this.fetchTableData();
        },
        upsertMaintenanceFeature(maintenancePlanContent) {
            const [f] = getFeaturesFromSections([maintenancePlanContent], this.data.projection, this.data.map.sectionAttributeName);
            if (!f) 
                return;

            const fid = f.getId(); // OBJECTID
            if (fid != null) {
                const existing = this.maintenanceSource.getFeatureById(fid);
                if (existing) 
                    this.maintenanceSource.removeFeature(existing);
            }

            this.maintenanceSource.addFeature(f);
        },
        deleteMaintenanceFromMap(objectId) {
            const f = this.maintenanceSource.getFeatureById(objectId);
            if (f) 
                this.maintenanceSource.removeFeature(f);
        },
        resetFormDataDialog() {
            // TODO chceme taky řešit přes dialog nebo stačí tahkel easy?
            this.defaultFormData();
        },
        async toggleLayer(item) {
            var self = this;
            var layerName = item.name;

            self.map.getLayers().forEach(async function (layer) {
                if (layer.get("name") === layerName) {
                    layer.setVisible(!item.visible);
                }
            });
        },
        getFeatureColor(status) {
            if(status === "offen") {
                return this.data.map.openMaintenanceColor;
            } else if (status === "erledigt") {
                return this.data.map.completedMaintenanceColor;
            } else {
                return this.data.map.createdMaintenanceColor;
            } 
        },
        async initMap() {
            var self = this;
            var { id, label } = self.data; 

            self.toolLayers = [];
            
            // release previous map
            if (self.map) {
                self.map.setTarget(undefined);
            }
            
            proj4.defs('ProjectEpsg' + id, self.data.projection);
            register(proj4);
            
            var layers = [];
            self.data.map.baseMaps.forEach(function(baseMap){
                var layer = createBaseLayer(baseMap, id);
                if(layer) {
                    layers.push(layer);
                }
            })

            var sections = await NetApi.loadRoutes(id, label);
            var features = getFeaturesFromSections(sections, this.data.projection, this.data.map.sectionAttributeName);
            if (features.length > 0) {
                var vector = new VectorLayer({ 
                    name: "Sections",
                    source: new VectorSource({ features: features }),
                    visible: true
                })
                vector.setZIndex(0);
                this.sectionsLayer = vector;

                vector.setStyle((feature, resolution) => { 
                    var isHighlighted = false;
                    if(self.sectionFilter && self.sectionFilter.length > 3 ) {
                        isHighlighted = (feature.get('name').toUpperCase()).indexOf(self.sectionFilter.toUpperCase()) >= 0;
                    }
                    return defaultLineStyleFunction(feature, resolution, self.data.map.lineColor, isHighlighted, self.data.map.highlightedLineColor || "#FF00F7");
                })
                layers.push(
                    vector
                );
            }

            this.maintenanceSections = await MaintenanceApi.list(id);
            var maintenanceFeatures = getFeaturesFromSections(this.maintenanceSections, this.data.projection, this.data.map.sectionAttributeName);

            this.maintenanceSource = new VectorSource();
            maintenanceFeatures.forEach(f => this.maintenanceSource.addFeature(f));
            this.maintenanceLayer = new VectorLayer({ 
                name: "Maintenance",
                source: this.maintenanceSource,
                visible: true
            })
            this.maintenanceLayer.setZIndex(10);
            this.maintenanceLayer.setStyle((feature, resolution) => {
                const oid = feature.getId();
                if (this.visibleMaintenanceIds && !this.visibleMaintenanceIds.has(oid))
                    return null;

                const featureColor = self.getFeatureColor(feature.get("properties")["status"]);
                return defaultLineStyleFunction(feature, resolution, featureColor, false, self.data.map.highlightedLineColor || "#FF00F7");
            })
            layers.push(
                this.maintenanceLayer
            );

            var styleSelectFunction = function (feature, resolution) {
                return defaultLineStyleFunction(feature, resolution, self.data.map.selectedLineColor || "#0000FF");
            }

            const overlay = new Overlay({
                element: self.$refs["popup"],
                autoPan: {
                    animation: {
                        duration: 250,
                    },
                }
            });

            self.$refs["popup-closer"].onclick = function() {
                overlay.setPosition(undefined);
                self.$refs["popup-closer"].blur();
                return false;
            };

            var view = new View({ center: parseCoords(self.data.map.center), zoom: 16 });
                self.map = new Map({
                    target: self.$refs["map"],
                    overlays: [overlay],
                    layers: layers,
                    view: view,
                });
            
            var features = [];

            const markers = new VectorLayer({
                source: new VectorSource({
                    features: features,
                }),
                style: new Style({
                    image: new Icon({
                        anchor: [0.5, 1],
                        src: src,
                    }),
                }),
                minZoom: 14,
            });

            self.map.addLayer(markers);  

            self.select = new Select({ 
                active: false, 
                style: styleSelectFunction,
                condition: (e) => {
                    // když je na pixelu maintenance feature, Sections select se neprovede
                    const hasMaintenance = self.map.hasFeatureAtPixel(e.pixel, {
                        layerFilter: (l) => l && l.get("name") === "Maintenance",
                    });
                    return singleClick(e) && !hasMaintenance;
                },
                layers: (layer) => layer && layer.get("name") === "Sections",
            });
            self.select.on('select', async function (evt) {
                self.sectionSelected(evt.selected);
            });

            self.map.addInteraction(self.select);

            var select = new Select();

            self.maintenanceSelect = new Select({
                layers: (layer) => layer && layer.get("name") === "Maintenance",
                style: styleSelectFunction
            });

            self.maintenanceSelect.on("select", (evt) => {
                self.maintenanceSectionSelected(evt.selected);
            });

            self.map.addInteraction(self.maintenanceSelect);

            // var changeInteraction = function () {
            //     if (select !== null) {
            //         self.map.removeInteraction(select);
            //     }
            //     if (select !== null) {
            //         self.map.addInteraction(select);
            //         select.on('select', function (e) {
            //             displayFeatureInfo(e.mapBrowserEvent.pixel);
            //         });
            //     }
            // };

            // changeInteraction();

            self.map.getLayers().forEach(function (layer) {
                self.toolLayers.push(layer.values_)
            });

            self.editInspectionPoint = new Feature({
                geometry: new Point([1340237.2318636572, 6024536.137740121]),
                id: "inspection-drag-point",
                name: "Drag point"
            });

            var editInspectionPointSource = new VectorSource();
            editInspectionPointSource.addFeature(self.editInspectionPoint);

            self.editInspectionPointVector = new VectorLayer({
                source: editInspectionPointSource,
                visible: false,
                style: new Style({ image: new Icon({ color: self.cursorColor , src: targetsrc.toString() }) })
            });

            var modify = new Modify({ source: editInspectionPointSource });
            modify.on('modifyend', function (evt) {
                if(self.selectLastFeature && evt.features && evt.features.getLength() > 0) {
                    var feature = evt.features.item(0);
                    var lengthToPoint = self.getChainageFromFeature(self.selectLastFeature, feature);
                    if(lengthToPoint >= 0) {
                        if(self.cursorType == "von") {
                            self.$set(self.formData, "von", lengthToPoint);
                        } else {
                            self.$set(self.formData, "bis", lengthToPoint)
                        }
                    }
                }
            });
            this.map.addInteraction(modify);

            this.map.addLayer(self.editInspectionPointVector);

            const filterSections = document.createElement('div');
            filterSections.className = 'ol-control';
            filterSections.style = 'display:block; top:0.5em; right:24em;';
            filterSections.innerHTML = `<div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">🔍</span>
                                            </div>
                                            <input class="form-control" id="filter_sections" type="text" >
                                        </div>`;
            
            filterSections.addEventListener('input', function(event) {
                var { value } = event.target;
                self.sectionFilter = value;
            });

            self.map.addControl(new Control({ element: filterSections }));

            this.defaultFormData();
        },
        destroyMap() {
            if (this.map) {
                this.map.setTarget(undefined);
            }
        },
        sectionSelected(sections) {
            var self = this;
            if (sections && sections.length > 0) {
                const feature = sections[0];
                const properties = feature.getProperties();
                if(properties.objectAttributes) {
                    var attrs = properties.objectAttributes;
                    if(attrs) {
                        for(var i in attrs) {
                            self.formData[attrs[i].name] = attrs[i].value;
                        }
                    }
                }
                
                self.formData.von = 0;
                self.formData.bis = 0;
                
                self.formData.sectionId = properties.id;
                self.formData.sectionName = properties.name;
                
                // Naplnění dat o sekci
                self.formDataSection.type = properties.type;
                self.formDataSection.properties = properties.properties;
                self.formDataSection.coordinates = properties.coordinates;
                // set cross visible
                self.editInspectionPointVector.setVisible(true)
                self.selectLastFeature = feature;
                self.setPrositionCrossIndicator("von", self.formData.von);
                

                self.setCursor("von");
            } else {
                self.defaultFormData();
                self.selectLastFeature = null;
                self.setCursor("");
                self.editInspectionPointVector.setVisible(false)
            }
            
            // this.fetchTableData();
        },
        maintenanceSectionSelected(sections) {
            var self = this;
            
            // Vyčistím vybrané sections / cursor / 
            if(self.select) {
                self.setCursor("");
                self.editInspectionPointVector.setVisible(false)
                self.select.getFeatures().clear();
            }

            if (sections && sections.length > 0) {
                const feat = sections[0];
                if (!feat) 
                    return;

                const props = feat.get("properties");
                if (!props)
                    return;

                const maintenanceCoordinates = feat.get("coordinates");
                const maintenanceType = feat.get("type");
                const maintenanceProps = feat.get("properties");

                self.formConstraints.formEditing = true;
                Object.assign(self.formData, props); // tady zůstane von/bis z MS

                this.editingRowId = maintenanceProps.OBJECTID;


                self.formDataSection.type = maintenanceType;
                self.formDataSection.properties = maintenanceProps;
                self.formDataSection.coordinates = maintenanceCoordinates;
            } else {
                self.formConstraints.formEditing = false;
                this.editingRowId = null;
                self.defaultFormData();
            }

            // this.fetchTableData();
        },
        setPrositionCrossIndicator(type, chainage){
            var pointChange = parseFloat(chainage);

            var selectLastFeatureGeometry = this.selectLastFeature.getGeometry();
            var length = this.selectLastFeature.get("length");
            var fraction = Math.trunc(pointChange) / Math.trunc(length);
            var coordinate = selectLastFeatureGeometry.getCoordinateAt(fraction);
            var nextPoint = new Point(coordinate);

            this.editInspectionPoint.setGeometry(nextPoint);
            if(type == "von") {
                this.editInspectionPointVector.setStyle(new Style({ image: new Icon({ color: "orange" , src: targetsrc.toString() }) }));
            } else {
                this.editInspectionPointVector.setStyle(new Style({ image: new Icon({ color: "blue" , src: targetsrc.toString() }) }));
            }
        },
        resetFormClass() {
            var self = this;
            for(var i in self.formClass) {
                self.formClass[i] = false;
            }
        },
        resetCursor() {
            var self = this;

            self.setCursor("");
            self.editInspectionPointVector.setVisible(false)
            self.select.getFeatures().clear();
            self.formConstraints.formEditing = false;
        },
        defaultFormData(continueCreating) {
            let attrs = this.data.form.attributes;
            for(var key in attrs) {
                if(!attrs[key].useInMaintenanceTable) // || key == "sectionId" || key == "sectionName"
                    continue;
                if(continueCreating && (key == "sectionId" || key == "sectionName")) 
                    continue;
                
                var defVal = attrs[key].defaultValue || "";
                if(attrs[key].type == "date" && attrs[key].defaultClass == "1") {
                    defVal = moment().format('YYYY-MM-DD');
                }
                this.$set(this.formData, key, defVal)
            }
        },
        setNewCoordinates(type) {
            if(type == "von") {
                var findIndexVon = this.tableForm.find(s => parseFloat(s.von) < parseFloat(this.formData.von) && parseFloat(this.formData.von) < parseFloat(s.bis) && s.guid != this.formData.guid);
                if(findIndexVon) {
                    this.requiredVON = "required";
                    this.requirement = true
                } else {
                    this.requiredVON = "";
                    this.requirement = false
                }
                this.formConstraints.minBisLenght = this.formData.von; // set minimum for BIS
                this.setPrositionCrossIndicator(type, this.formData.von);
            } else if (type == "bis") {
                var findIndexBis = this.tableForm.find(s => parseFloat(s.von) < this.formData.bis && this.formData.bis < parseFloat(s.bis)  && s.guid != this.formData.guid);
                if(findIndexBis) {
                    this.requiredBIS = "required";
                    this.requirement = true
                } else {
                    this.requiredBIS = "";
                    this.requirement = false
                }
                this.setPrositionCrossIndicator(type, this.formData.bis);
            }
        },
        setCursor(type) {
            if(this.selectLastFeature) {
                this.cursorType = type;
                if(type == "von") {
                    this.setPrositionCrossIndicator(type, this.formData.von);
                } else if (type == "bis") {
                    this.setPrositionCrossIndicator(type, this.formData.bis);
                }
            }
        },
        setPositionVON(type) {
            let self = this
            if(type == "start") {
                if(self.selectLastFeature) {
                    self.cursorType = "von";
                    self.formData.von = "0";
                    self.setPrositionCrossIndicator("von", self.formData.von);
                }
            } else if(type == "gps") {
                if(self.selectLastFeature && self.gpsSource) {
                    var features = self.gpsSource.getFeatures();
                    if(features.length) {
                        self.cursorType = "von";
                        self.formData.von = parseFloat(self.getChainageFromFeature(self.selectLastFeature, features[0])).toFixed(2);
                        self.setPrositionCrossIndicator("von", self.formData.von);
                    }
                }
            } else if(type == "end") {
                if(self.selectLastFeature) {
                    self.cursorType = "von";
                    self.formData.von = self.selectLastFeature.get("length").toFixed(2);
                    self.setPrositionCrossIndicator("von", self.formData.von);
                }
            }
        },
        setPositionBIS(type) {
            let self = this
            if(type == "start") {
                if(self.selectLastFeature) {
                    self.cursorType = "bis";
                    self.formData.bis = 0;
                    self.setPrositionCrossIndicator("bis", self.formData.bis);
                }
            } else if(type == "gps") {
                if(self.selectLastFeature && self.gpsSource) {
                    var features = self.gpsSource.getFeatures();
                    if(features.length > 0) {
                        self.cursorType = "bis";
                        self.formData.bis = parseFloat(self.getChainageFromFeature(self.selectLastFeature, features[0])).toFixed(2);
                        self.setPrositionCrossIndicator("bis", self.formData.bis);
                    }
                }
            } else if(type == "end") {
                if(self.selectLastFeature) {
                    self.cursorType = "bis";
                    self.formData.bis = self.selectLastFeature.get("length").toFixed(2);
                    self.setPrositionCrossIndicator("bis", self.formData.bis);
                }
            }
        },
        getChainageFromFeature(line, feature) {
            if(line && feature) {
                var lineGeometry = line.getGeometry();
                var realLength = line.get("length");
                var point = feature.getGeometry()
                var firstPoint = point.getFirstCoordinate();

                var lengthToPoint = lineStringLengthToCoordinates(lineGeometry, realLength, firstPoint[0], firstPoint[1]);
                return lengthToPoint.toFixed(2);
            }
        },
        sortColumnBy(name) {
            if (this.sortBy === name) {
                this.sortBy = "-" + name;
            } else if (this.sortBy === "-" + name) {
                this.sortBy = "";
            } else {
                this.sortBy = name;
            }

            if (this.tableFiltersRestoring)
                return;

            this.saveTableState();
            this.fetchTableData();
        },
        filter(name, value, { debounced = true } = {}) {
            this.$set(this.filterObject, name, value);

            if (this.tableFiltersRestoring)
                return;

            this.saveTableState();

            if (debounced) {
                this.fetchTableDataDebounced();
            } else {
                this.fetchTableData();
            }
        }
    },
    data() {
        return {
            sections: [],
            sectionFilter: "",
            maintenanceSections: [],
            maintenanceLayer: null,
            maintenanceSource: null,
            summaryList: {},
            isMounted: false,
            showForm: true,
            selectLastFeature: null,
            map: null,
            toolLayers: [],
            data: {
                form: "default",
                map: {
                    baseMaps: [],
                },
            },
            absoluteClass: "h-100 position-absolute",
            defaultClass: "",
            tableForm: [],
            formConstraints: {
                formEditing: false,
                maxLineLength: 0,
                minBisLenght: 0,
            },
            formData: {},
            formDataSection: {},
            formClass: {},
            showDeleteRowDialog: false,
            fetchTableDataDebounced: null,
            filterObject: {},
            sortBy: "",
            tableFiltersRestoring: false,
            visibleMaintenanceIds: null,
            editingRowId: null
        };
    }
};
</script>

<style scoped>
.table-row-editing {
    background-color: #fff3cd;
}

.table-row-editing td {
    background-color: #fff3cd;
}
.side-form {
  position: fixed;
  top: 56px;
  right: 0;
  height:calc(70% - 1rem);
  width: 360px;
  background: #fff;
  border-left: 1px solid #dee2e6;
  z-index: 200;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
}

.side-form__header {
  padding: 8px;
  border-bottom: 1px solid #dee2e6;
}

.side-form__content {
  padding: 8px;
  flex: 1;
}

.sidepanelForm {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.sidepanelForm__header {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #fff;
  padding: 8px 0;
  margin: 0;
  border-bottom: 1px solid #dee2e6;
  flex-shrink: 0;
}

.sidepanelForm__content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 8px;
}

.sidepanelForm .row {
  margin-left: 0;
  margin-right: 0;
}
.sidepanelForm .col-form-label {
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  align-items: center;
}
.sidepanelSection {
  border-top: 1px solid #dee2e6;
  margin-top: 8px;
  padding-top: 6px;
}
table {
  border-collapse: separate;
  border-spacing: 0;
}

th {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  border-bottom: 1px solid #EB9486;
}

.map-viewport {
    position: fixed;
    top: 56px;
    right: 0;
    left: 0;
    z-index: 100;
    height: 70%;
    padding-bottom: 1rem;
}

.map-viewport .map {
    height: 100%;
    width: 100%;
}
.fixed-bottom {
    overflow: scroll;
    top: calc(70% + 56px);
    padding: 0 1rem 1rem 1rem;
}
.fixed-container {
    height: 100%;
    width: 100%;
}
.ol-popup {
    position: absolute;
    background-color: white;
    -webkit-filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
    filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 140px;
}
.ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}
.ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
}
.ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
}
.ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: -2px;
    right: 0px;
}
.ol-popup-closer:after {
    content: "✖";
}
</style>